<template>
    <div class="container">
      <v-card
        class="card"
        :style="{
          width: isMobile ? '100%' : '70%',
          padding: isMobile ? '10px' : '0px',
          height: isMobile ? '700px' : '460px',
          borderRadius: isMobile ? '0px' : '0px',
          marginTop: isMobile ? '0px' : '0px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center'
        }"
        style="
        background-color: #FFFFFF;
        "
        elevation="0"
      >


        <div class="image-section" style="flex: 1; display: flex; justify-content: center;">
          <img src="/images/nextcloud/nextcloud-file-preview.png" :width="isMobile ? '700' : '700'">
        </div>
        <div class="text-section" style="flex: 1; padding-left: 30px;">
          <div
          :style="{
            fontSize: isMobile ? '30px' : '22px',
            fontWeight: isMobile ? '900' : '900',
          }">
            넥스트클라우드 파일
          </div>
  
            <div
              :style="{
                fontSize: isMobile ? '15px' : '15px',
                fontWeight: isMobile ? '100' : '500',
                paddingTop: '20px',
              }"
            >
              Nextcloud Files는 강력한 협업 기능을 갖춘 셀프 호스팅 파일 저장 및 동기화 플랫폼으로 데스크탑, 모바일, 웹 인터페이스를 통해 제공됩니다.
            </div><br>
            <div
              :style="{
                fontSize: isMobile ? '14px' : '15px',
                fontWeight: isMobile ? '100' : '500',
              }"
            >
              파일 동기화, 공유 및 협업을 쉽게 할 수 있는 안전한 클라우드 저장 및 파일 공유 소프트웨어입니다.
            </div>
            
        </div>
  
      </v-card>
    </div>
  </template>
  
  <script>
  import { useRouter } from 'vue-router';
  import { ref, computed, onMounted } from 'vue';
  
  export default {
    setup() {
      const router = useRouter();
      const isMobile = ref(false);
  
      const checkIsMobile = () => {
        isMobile.value = window.innerWidth <= 768; // Check if the window width is less than or equal to 768px
      };
  
      const goToestimate = () => {
        router.push('/estimate');
      }
  
      onMounted(() => {
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
      });
  
      return {
        goToestimate,
        isMobile: computed(() => isMobile.value),
        isDesktop: computed(() => !isMobile.value),
      };
    },
  };
  </script>
  
  <style scoped>
  .container {
    display: flex;
    justify-content: center;
  }
  
  
  
  /* Styles for mobile */
  @media screen and (max-width: 768px) {
    .text-section {
      padding: 0px 20px 0 20px;
    }
  }
  </style>
  